import { render } from "./ProductGroups.vue?vue&type=template&id=71e12d0f"
import script from "./ProductGroups.vue?vue&type=script&lang=js"
export * from "./ProductGroups.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/data/dev.bl8m.it/vhosts/clients/client0/web144/web/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__